/** @jsxImportSource @emotion/react */

import React, { useRef } from 'react';
import styled from 'styled-components';
import Scroll from '@component/common/scroll';
import * as size from '@constant/size';
import { isMobile } from 'react-device-detect';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import BeginToday from '@component/moashelf/newsletter/begin/begin-today';
import BeginFind from '@component/moashelf/newsletter/begin/begin-find';
import BeginTip from '@component/moashelf/newsletter/begin/begin-tip';
import { IMoashelfMenu } from '@datatype/moashelf/type';

interface IProps {
  mode: IMoashelfMenu['sub'];
}

const Video = styled.video``;

const lyrics = [
  { text: '夢ならばどれほどよかったでしょう', start: 5 },
  { text: '未だにあなたのことを夢にみる', start: 12 },
  { text: '忘れた物を取りに帰るように', start: 20 },
];

const Wrapper = styled.div`
  height: 100%;
  padding: 0 ${IS_IYAGIGO_MOBILE_VIEW ? size.MARGIN_1 : size.MARGIN_2} 0 ${IS_IYAGIGO_MOBILE_VIEW ? size.MARGIN_1 : size.MARGIN_2};
`;

function VideoWithLyrics() {
  const videoRef = useRef<any>(null);

  const handleClick = (time) => {
    if (videoRef.current) {
      videoRef.current.currentTime = time; // 해당 위치로 이동
      videoRef.current.play(); // 클릭 시 바로 재생
    }
  };

  return (
    <div className='flex flex-col items-center space-y-4 p-6 bg-gray-100'>
      {/* 비디오 */}
      <video
        ref={videoRef}
        src='https://content-local.otterbrick.com/iyagigo/ky-lemon.mp4'
        controls
        className='w-[400px] rounded-lg shadow-lg'
      />

      {/* 가사 */}
      <div className='mt-4 space-y-2'>
        {lyrics.map((line, index) => (
          <p key={index} onClick={() => handleClick(line.start)} className='cursor-pointer hover:text-blue-600'>
            {line.text}
          </p>
        ))}
      </div>
    </div>
  );
}

const Begin: React.FC<IProps> = ({ mode }) => {
  return (
    <Wrapper>
      <Scroll direction='y' height={isMobile ? '100%' : '100%'}>
        {/*{'안녕'}*/}
        {/*<VideoWithLyrics />*/}
        {/*<Video width={'800px'} src={'https://content-local.otterbrick.com/iyagigo/ky-lemon.mp4'} controls={true} />*/}
        {mode === 'begin-today' && <BeginToday />}
        {mode === 'begin-find' && <BeginFind />}
        {mode === 'begin-tip' && <BeginTip />}
      </Scroll>
    </Wrapper>
  );
};

export default Begin;
